import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
    content: {
      backgroundColor: '#fff',
      position: 'relative',
      maxWidth: '430px',
      width: '100%',
      maxHeight: '90vh',
      padding: '15px',
      borderRadius: '8px',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      '@media (max-width: 768px)': {
        maxHeight: '95vh',
        margin: '0',
        borderRadius: '8px 8px 0 0',
      },
    },
    header: {
      display: 'flex',
      flexDirection: 'column',
      padding: '44px 24px 24px 24px',
      gap: '8px',
      flexShrink: 0,
    },
    closeIcon: {
      position: 'absolute',
      right: '15px',
      top: '15px',
      cursor: 'pointer',
    },
    title: {
      fontWeight: 700,
      fontSize: '20px',
      textAlign: 'center',
    },
    subtitle: {
      fontWeight: 400,
      fontSize: '16px',
      color: 'rgba(0, 0, 0, 0.87)',
      textAlign: 'center',
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0 15px 15px 15px',
      gap: '15px',
      overflow: 'auto',
      flex: 1,
      minHeight: 0,
    },
  }
))
